module.exports = __webpack_public_path__ + "img/up-host-yellow.918eab04.svg";